export class ParentTaskModel {
  TaskId?: number;
  Name!: string;
  NamespaceId!: string;
  NamespaceName!: string;
  QueueTaskId!: string;
  QueueTaskName!: string;
  IconId!: string;
  IconUrl!: string;
  ColorId!: string;
  Color!: string;
  constructor(obj?: Partial<ParentTaskModel>) {
    if (obj) Object.assign(this, obj);
  }
}
